<template>
  <div class="wrap">
    <div class="search-page-wrap">
      <div class="data-table-title white">ご利用プラン・会社情報</div>
      <!-- テーブルタイトル -->

      <el-tabs v-model="activeName" class="tab-report">
        <el-tab-pane label="ご利用プラン" name="plan">
          <div class="setting-wrap" style="min-height:260px" v-loading="loading" v-if="loading"></div>
          <plan :userdata="userdata" v-if="!loading"/>
        </el-tab-pane>

        <el-tab-pane label="会社情報" name="company_info">
          <companyInfo :userdata="userdata"/>
        </el-tab-pane>

        <el-tab-pane label="メンバー管理" name="member">
          <Member/>
        </el-tab-pane>

        <el-tab-pane label="ブランド管理" name="brand" v-if="manage_brand_enabled">
          <Brand />
        </el-tab-pane>

        <el-tab-pane label="請求先情報" name="bill_info" v-if="!userdata.thirdparty_app&&permission">
          <paymentInfo :userdata="userdata"/>
        </el-tab-pane>

        <el-tab-pane label="請求履歴" name="invoice" v-if="!userdata.thirdparty_app&&permission">
          <paymentHistory :userdata="userdata"/>
        </el-tab-pane>
      </el-tabs>
    </div>


  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const getUserDataAPI = root + "/api/auth/load_userdata";
import plan from "./plan";
import companyInfo from "./company_info";
import Member from "./member";
import Brand from "./brand";
import paymentInfo from "./payment_info";
import paymentHistory from "./payment_history";
// import EmailandPassword from "./email_password";


export default {
  name: "setting",
  components: {
    plan,
    companyInfo,
    Member,
    Brand,
    paymentInfo,
    paymentHistory,
    // EmailandPassword,
  },
  data() {
    return {
      activeName: "plan",
      loading: true,
      userdata: {},
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      if (this.$store.state.permission.company_setting) {
        return this.$store.state.permission.company_setting.access;
      } else {
        return false
      }
    },
    activate() {
      return this.$store.state.activate;
    },
    manage_brand_enabled() {
      return this.$store.state.service_plan.manage_brand_enabled;
    },
  },
  mounted() {
    this.loadUserData();
    this.loadActive();
    this.scrollTop();
    this.$store.dispatch("changeActive", "setting");
  },
  methods: {
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    loadActive() {
      if (this.$route.query.activeName == null) {
        this.activeName = "plan";
      } else {
        this.activeName = this.$route.query.activeName;
      }
    },
    loadUserData() {
      this.axios
        .get(getUserDataAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            type: "setting"
          },
        })
        .then((response) => {
          this.userdata = response.data;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
  watch: {
    $route(to) {
      this.loadActive();
      this.scrollTop();
      if (to.path == "/setting/upgrade") {
        this.$router.push("/setting");
      }
    },
  },
  filters: {
  },
};
</script>
